<template>
  <div class="ma-2 mr-4 pl-2">
    画像ファイルをアップロードするか、画像URLを入力してください。
    <p class="caption">
      ※
      記事中では400×400のサイズにて表示するため、そのサイズに綺麗に表示される縦横比・解像度の画像が推奨されます
    </p>
    <v-card outlined max-width="450" class='mt-3 ml-2'>
      <v-form ref='productImageForm' style='display: flex;' class='mt-3 ml-5 mr-5'>
        <ImageFormAndThumbnail
          ref="imageFormAndThumbnail"
          label-name='画像ファイル'
          @change-image-file="(value) => productImageFile = value"
        ></ImageFormAndThumbnail>
        <v-btn class="ml-3 mt-4 white--text" color="blue" small @click="uploadProductImage">
          追加
        </v-btn>
      </v-form>
    </v-card>
    <v-card outlined class='mt-3 ml-2' max-width="450">
      <v-form style='display: flex;' class='mt-4 ml-5 mr-5'>
        <v-text-field
          v-model="productImageDirectUrl"
          :rules="[urlValidation]"
          type="url"
          label="画像URL"
          clearable
          dense
        >
          <template v-slot:label>
            <InputLabel labelName="画像URL" />
          </template>
        </v-text-field>
        <v-btn class="ml-3 mt-1 white--text" color="blue" small @click="uploadProductImage">
          追加
        </v-btn>
      </v-form>
    </v-card>
    <sort-images
      :value="editingImages"
      class="sortImagesRow"
      @change="updateSortImages"
      @change-reference-url="updateReferenceUrl"
      @remove-image="removeImage"
    />
  </div>
</template>

<script>
import SortImages from '@/components/commons/productIntroductions/SortImages'
import { mapState } from 'vuex'
import formValidationUtils from '@/mixins/form_validation_utils'
import axios from 'axios'
import { cloneDeep } from 'lodash'
import ImageFormAndThumbnail from '../ImageFormAndThumbnail'
import InputLabel from '@/components/commons/formParts/inputLabel'

export default {
  name: 'ImagesForm',
  components: {
    SortImages,
    ImageFormAndThumbnail,
    InputLabel
  },
  mixins: [formValidationUtils],
  props: {
    affiImages: {
      type: Array,
      required: true
    }
  },
  data: () => {
    return {
      editingImages: [],
      productImageFile: null,
      productImageDirectUrl: ''
    }
  },
  computed: {
    ...mapState({
      editingItemable: (state) => state.PostEditor.editingItemable
    })
  },
  watch: {
    affiImages: function (images) {
      const editingImageValues = this.editingImages.map(
        (editingImage) => editingImage.value
      )
      images.forEach((image) => {
        if (editingImageValues.includes(image)) {
          return false
        }
        let addImageObject = {}
        addImageObject.type = 'url'
        addImageObject.value = image
        this.editingImages.push(addImageObject)
      })
      this.$emit('update-editing-itemable-images', [...this.editingImages])
    }
  },
  mounted: function () {
    this.editingImages.push(...(this.editingItemable.images || []))
  },
  methods: {
    updateSortImages (images) {
      this.editingImages.splice(0, this.editingImages.length)
      this.editingImages.push(...images)
      this.$emit('update-editing-itemable-images', images)
    },
    updateReferenceUrl (...args) {
      const [url, index] = args
      let changedImages = cloneDeep(this.editingItemable.images)
      changedImages[index].referenceUrl = url
      this.$emit('update-editing-itemable-images', changedImages)
      this.updateSortImages(changedImages)
    },
    removeImage (index) {
      let changedImages = cloneDeep(this.editingImages)
      changedImages.splice(index, 1)
      this.$emit('update-editing-itemable-images', changedImages)
      this.editingImages.splice(index, 1)
    },
    uploadProductImage () {
      if (this.editingImages.length >= 6) {
        const payload = {
          color: 'warning',
          text: '登録出来る画像は6枚までです'
        }
        this.$store.commit('SystemMessageStore/create', payload)
        return true
      }

      if (this.productImageFile) {
        let formData = new FormData()
        formData.append('download_image[file]', this.productImageFile)
        formData.append('download_image[variety]', 'product_introduction')
        this.$store.dispatch('LoaderStore/displayLoader')
        axios
          .post('/api/download_images', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          .then(
            ({ data }) => {
              const newDownloadImageObject = this.newDownloadImageObject(
                data.data.attributes
              )
              this.$emit(
                'update-editing-itemable-images',
                this.addedEditingImages(newDownloadImageObject)
              )
              const payload = {
                status: 200,
                message: '画像を選択しました'
              }
              this.$store.dispatch('SystemMessageStore/createMessage', payload)
              this.productImageFile = null
              this.$refs.imageFormAndThumbnail.imageFile = null
              this.$refs.imageFormAndThumbnail.imagePreviewURL = null
            },
            (error) => {
              this.$store.dispatch('LoaderStore/hideLoader')
              const payload = {
                status: error.response.status,
                message: error.response.data.errors.toString()
              }
              this.$store.dispatch('SystemMessageStore/createMessage', payload)
            }
          )
          .finally(() => {
            this.$store.dispatch('LoaderStore/hideLoader')
          })
      } else {
        let addImageObject = {}
        addImageObject.type = 'url'
        addImageObject.value = this.productImageDirectUrl
        this.$emit(
          'update-editing-itemable-images',
          this.addedEditingImages(addImageObject)
        )
        this.productImageDirectUrl = null
      }
    },
    newDownloadImageObject (responseAttributes) {
      const downloadImage = responseAttributes
      let addImageObject = {}
      addImageObject.type = 'download_image_id'
      addImageObject.value = downloadImage.id
      addImageObject.downloadImageUrl = downloadImage.fileUrl
      return addImageObject
    },
    addedEditingImages (newImageObject) {
      let changedImages = cloneDeep(this.editingImages)
      changedImages.push(newImageObject)
      this.editingImages.splice(0)
      this.editingImages.push(...changedImages)
      return changedImages
    }
  }
}
</script>

<style scoped>
.sortImagesRow {
  justify-content: space-around;
}
</style>
